export default "__VITE_ASSET__CReaeFGu__"